var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#1E3932"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#1E3932"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#1E3932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.fa135a0a992339740a5179ffbb6b947d.svg";
export { ForwardRef as ReactComponent };